import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  InputAdornment,
  CircularProgress,
} from "@mui/material";

// Common countries list
const countries = [
  { code: "CH", name: "Switzerland" },
  { code: "US", name: "United States" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "IT", name: "Italy" },
  { code: "GB", name: "United Kingdom" },
  { code: "ES", name: "Spain" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "JP", name: "Japan" },
  { code: "AT", name: "Austria" },
  { code: "BE", name: "Belgium" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "GR", name: "Greece" },
  { code: "IE", name: "Ireland" },
  { code: "LU", name: "Luxembourg" },
  { code: "NL", name: "Netherlands" },
  { code: "NO", name: "Norway" },
  { code: "PT", name: "Portugal" },
  { code: "SE", name: "Sweden" },
  { code: "BR", name: "Brazil" },
  { code: "CN", name: "China" },
  { code: "IN", name: "India" },
  { code: "RU", name: "Russia" },
  { code: "ZA", name: "South Africa" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "SG", name: "Singapore" },
  { code: "KR", name: "South Korea" },
  { code: "MX", name: "Mexico" },
];

/**
 * Reusable Country Select Dropdown Component
 *
 * @param {object} props - Component props
 * @param {string} props.label - The label for the select field
 * @param {string} props.value - The current selected country code (ISO 3166-1 alpha-2)
 * @param {function} props.onChange - Callback function when the value changes
 * @param {boolean} [props.required=false] - Whether the field is required
 * @param {boolean} [props.disabled=false] - Whether the field is disabled
 * @param {object} [props.error] - Error object from validation (e.g., react-hook-form)
 * @param {string} [props.helperText] - Helper text to display below the field
 * @returns {JSX.Element} The CountrySelect component
 */
const CountrySelect = ({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  error,
  helperText,
  ...rest
}) => {
  const [loading] = useState(false);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  // Find selected country
  const selectedCountry = countries.find((c) => c.code === value);
  console.log(
    `CountrySelect: Value=${value}, Selected=${selectedCountry?.name || "None"}`
  );

  return (
    <TextField
      select
      fullWidth
      label={label}
      value={value || ""}
      onChange={handleChange}
      required={required}
      disabled={disabled || loading}
      error={!!error}
      helperText={error?.message || helperText}
      {...rest}
    >
      <MenuItem value="">
        <em>Select a country</em>
      </MenuItem>

      {countries
        .sort((a, b) => a.name.localeCompare(b.name)) // Sort alphabetically by name
        .map((country) => (
          <MenuItem key={country.code} value={country.code}>
            {country.name} ({country.code})
          </MenuItem>
        ))}
    </TextField>
  );
};

export default CountrySelect;
